import { createStore } from "owa-satcheljs";

interface CopilotAutoReschedulingNotificationsStore {
    shouldShowCopilotAutoReschedulingNotificationsCallout: boolean;
}

const defaultStore: CopilotAutoReschedulingNotificationsStore = {
    shouldShowCopilotAutoReschedulingNotificationsCallout: false,
};

export const getStore: () => CopilotAutoReschedulingNotificationsStore = createStore<CopilotAutoReschedulingNotificationsStore>("CopilotAutoReschedulingNotificationsStore", defaultStore);
